import { Link } from '@mui/material';
import { ContentBodyBox } from 'common-client';
import React, {
  useCallback, useContext, useMemo, useState,
} from 'react';
import { useHistory } from 'react-router-dom';
import { ConfigContext } from '../config';
import { Auction } from '../entities/Auction';
import { AuctionTableWrapper } from '../wrappers/AuctionTableWrapper';
import { CreateAuctionModalWrapper } from '../wrappers/createAuctionFlow/CreateAuctionModalWrapper';

export default function AuctionsRoute() {
  const history = useHistory();
  const { networkConfig } = useContext(ConfigContext);
  const [openCreateAuction, setOpenCreateAuction] = useState(false);

  const onCreateAuction = useCallback(() => {
    setOpenCreateAuction(true);
  }, [setOpenCreateAuction]);

  const onAuctionSelect = useCallback((auction: Auction) => {
    history.push(`/auction/${auction.address}`);
  }, [history]);

  const primaryButtonProps = useMemo(() => {
    if (networkConfig?.createAuctionDisabled) {
      return {
        label: 'Create Auction',
        tooltip: 'User created auctions are coming soon!',
        disabled: true,
      };
    }
    return {
      label: 'Create Auction',
      onClick: onCreateAuction,
    };
  }, [networkConfig?.createAuctionDisabled]);

  const secondaryButtonProps = useMemo(() => ({
    label: 'Documentation',
    link: 'https://docs.prl.one/buttonwood/learn/buttonauctions',
  }), []);

  return (
    <ContentBodyBox
      header="Button Auctions"
      body={(
        <>
          Create and join auctions for any pair of ERC-20 tokens.
          You can learn more about auctions in our
          {' '}
          <Link
            href="https://docs.prl.one/buttonwood/learn/tranche"
            target="_blank"
            rel="noreferrer"
          >
            documentation
          </Link>
          .
        </>
      )}
      primaryButtonProps={primaryButtonProps}
      secondaryButtonProps={secondaryButtonProps}
    >
      <AuctionTableWrapper
        onAuctionSelect={onAuctionSelect}
        onCreateAuction={onCreateAuction}
      />
      {openCreateAuction && (
        <CreateAuctionModalWrapper
          open={openCreateAuction}
          onExit={() => setOpenCreateAuction(false)}
        />
      )}
    </ContentBodyBox>
  );
}
